'use es6';

import { ensureFn, pick } from './helpers';

function extractProperty(objs = [], property = '', defaultValue = '') {
  const match = objs.find(obj => obj && typeof obj[property] !== 'undefined');
  return match ? match[property] : defaultValue;
}

export function isExpired(updatedAt, maxAge) {
  const timeInStoreMs = Math.abs(Date.now() - updatedAt);
  return timeInStoreMs > maxAge;
}
export function getCacheKey(treatmentKey, paramKey) {
  return `${treatmentKey}-${paramKey}`;
}
export function getCacheKeys({
  schema
}) {
  return Object.keys(schema).reduce((acc, treatmentKey) => {
    const {
      parameters,
      maxAge = undefined
    } = schema[treatmentKey];
    const parameterKeys = Object.keys(parameters);
    parameterKeys.forEach(paramKey => {
      acc.push({
        key: getCacheKey(treatmentKey, paramKey),
        maxAge
      });
    });
    return acc;
  }, []);
}
export function getOverridesFromSearch({
  cacheKeys,
  searchParamsObject = {}
}) {
  return pick(searchParamsObject, cacheKeys.map(({
    key
  }) => key));
}
export function getOverridesFromCache({
  cacheKeys,
  asyncStore,
  onError
}) {
  const asyncStoreValues = [];
  const overrides = {};

  const onErrorWithExtra = e => {
    ensureFn(onError)(e, {
      fingerprint: ['laboratory-lib', 'lab:getOverridesFromCache']
    });
  };

  if (typeof asyncStore === 'function') {
    cacheKeys.forEach((cacheKey = {}) => {
      const asyncValue = asyncStore('get', cacheKey.key).then((cacheEntry = {}) => {
        const {
          updatedAt = 0,
          value = ''
        } = cacheEntry || {};

        if (value && updatedAt) {
          const key = extractProperty([cacheKey, cacheEntry], 'key', '');
          const maxAge = extractProperty([cacheKey, cacheEntry], 'maxAge', 0);

          if (!isExpired(updatedAt, maxAge)) {
            overrides[key] = value;
          }
        }
      }).catch(onErrorWithExtra);
      asyncStoreValues.push(asyncValue);
    });
  }

  return Promise.all(asyncStoreValues).then(() => overrides);
}
export function saveOverridesToCache({
  schema,
  treatments,
  asyncStore,
  onError
}) {
  const asyncStoreValues = [];

  const onErrorWithExtra = e => {
    ensureFn(onError)(e, {
      fingerprint: ['laboratory-lib', 'lab:saveOverridesToCache']
    });
  };

  if (typeof asyncStore === 'function') {
    Object.keys(treatments).forEach(treatmentKey => {
      const treatment = treatments[treatmentKey];
      Object.keys(treatment.parameters).forEach(paramKey => {
        const cacheKey = getCacheKey(treatmentKey, paramKey);
        asyncStore('get', cacheKey).then((cacheEntry = {}) => {
          const {
            updatedAt = 0
          } = cacheEntry || {};
          const maxAge = extractProperty([schema[treatmentKey], treatment, cacheEntry], 'maxAge', 0);
          const value = treatment['parameters'][paramKey];

          if (maxAge > 0 && isExpired(updatedAt, maxAge)) {
            const result = asyncStore('set', cacheKey, {
              key: cacheKey,
              updatedAt: Date.now(),
              maxAge,
              value
            }).catch(onErrorWithExtra);
            asyncStoreValues.push(result);
          } else if (!!updatedAt && maxAge === 0) {
            const result = asyncStore('delete', cacheKey).catch(onErrorWithExtra);
            asyncStoreValues.push(result);
          }
        }).catch(onErrorWithExtra);
      });
    });
  }

  return Promise.all(asyncStoreValues);
}